/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-03-05",
    versionChannel: "nightly",
    buildDate: "2023-03-05T00:24:08.325Z",
    commitHash: "33064465b3311df870cbc20337d524bad47b5ee1",
};
